import { useEffect, useState } from "react";
import axios from "axios";
import { getMembershipPayments } from "apis/v3/authApi";
import {
  CANCEL_MEMBERSHIP_RECENT_PAYMENT_HOURS,
  hasCompletedPaymentWithinHours
} from "utils/v3/membershipPaymentsUtils";

export function useRecentMembershipPayment(
  withinHours: number = CANCEL_MEMBERSHIP_RECENT_PAYMENT_HOURS
) {
  const [hasRecentPayment, setHasRecentPayment] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    setIsLoading(true);
    getMembershipPayments()
      .then((response) => {
        if (cancelled) {
          return;
        }
        if (response && !axios.isAxiosError(response)) {
          const payments = response.data?.data?.payments ?? [];
          setHasRecentPayment(
            hasCompletedPaymentWithinHours(payments, withinHours)
          );
        } else {
          setHasRecentPayment(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setHasRecentPayment(false);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [withinHours]);

  return { hasRecentPayment, isLoading };
}
